// extracted by mini-css-extract-plugin
export default {"itemWrapper":"listItemWrapper_itemWrapper__PGz36"};